export const importErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
        var moduleName = null

        if (desyncdata.indexOf('ModuleNotFoundError: No module') !== -1 || desyncdata.indexOf('ImportError: No module') !== -1) {
            const indexOfNoModuleName = desyncdata.indexOf('No module named ')
            moduleName = desyncdata.slice(indexOfNoModuleName, indexOfNoModuleName + 128).split('\'')[1].trim()
        } else if (desyncdata.indexOf('ZipImportError: can\'t find module') !== -1) {
            const indexOfNoModuleName = desyncdata.indexOf('can\'t find module ')
            moduleName = desyncdata.slice(indexOfNoModuleName, indexOfNoModuleName + 128).split('\'')[2].trim()
        }

		if (desyncdata.indexOf('ImportError: cannot import') !== -1 || desyncdata.indexOf('ImportError: No module') !== -1 || desyncdata.indexOf('ModuleNotFoundError: No module') !== -1 || desyncdata.indexOf('ZipImportError: can\'t find module') !== -1) {
			return {
				type: 'importErrorTest' + moduleName,
				color: 'IndianRed',
				title: 'Script Mod Import Error' + ((moduleName != null) ? ' (' + moduleName + ')' : ''),
				text: 'Broken/Outdated mod is importing ' + ((moduleName != null) ? 'the \'<strong>' + moduleName + '</strong>\' module.' : 'script files.'),
				description: 'A broken or outdated modification is attempting to import ' + ((moduleName != null) ? 'the \'<strong>' + moduleName + '</strong>\' module' : 'game code') + ' and fails. The mod is too new, the game is too old, or the required mod is missing.<br/><br/>' +
                             'You need to locate the TS4SCRIPT file, in your The Sims 4 Mods folder, that could be causing this issue and remove it.<br/>' +
                             'If this is a new issue, try removing the most recent mod you have installed.<br/><br/>' +
                             'In some cases, a mod is required to be installed alongside a different mod. Make sure you have all of the required mods.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>a530079ba138bfea5bcaa005</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-10-19 23:29:02</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>none</categoryid>
        <desyncid>a530079ba138bfea5bcaa005</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Failure: '' () (ImportError: cannot import name SimInfoTest)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 119, in import_modules_by_path
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\custom_import.py&quot;, line 72, in load_module
ImportError: cannot import name 'SimInfoTest'
</desyncdata>
    </report>
</root>

<root>
    <report>
        <version>2</version>
        <sessionid>f4a6baeaf08a84965ca25224</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-04-02 03:04:13</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.49.1020-1.200.000.373.Release</buildsignature>
        <categoryid>utils.py:116</categoryid>
        <desyncid>f4a6baeaf08a84965ca25224</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Failure: 'poseplayer/__init__' (poseplayer) (ModuleNotFoundError: No module named 'poseplayer')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 119, in import_modules_by_path
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\importer\utils.py&quot;, line 116, in import_modules_by_path
ModuleNotFoundError: No module named 'poseplayer'
rtim=0</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/importErrorTest.js